module.exports = __webpack_public_path__ + "img/empty-conflicts.17362093.svg";